const description = `Foodie Buddies is a podcast dedicated to talking about food
and cooking built on a foundation of friendship, respect, and
inclusivity.`;

export default description;
